var map = {
	"./de/btn-back.png": "TjPl",
	"./en/btn-back.png": "IXLK",
	"./es/btn-back.png": "2ABg",
	"./fr/btn-back.png": "c6v+",
	"./ja/btn-back.png": "j+nK",
	"./ko/btn-back.png": "dgJR",
	"./pt/btn-back.png": "byF2",
	"./ru/btn-back.png": "aejA",
	"./th/btn-back.png": "eVKF",
	"./zh-Hant/btn-back.png": "Pogm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CPaF";